import { Playground, Props } from 'docz';
import { Button } from "../../../../../src/template/Button";
import * as React from 'react';
export default {
  Playground,
  Props,
  Button,
  React
};